import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-archive-billing-programs',
  templateUrl: './tryout-archive-billing-programs.component.html',
  styleUrls: ['./tryout-archive-billing-programs.component.css']
})
export class TryoutArchiveBillingProgramsComponent implements OnInit {

  @Input() NoOfArchiveBillingPrograms: string;
  @Output() filterProgramsEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterProgramListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-archive-billing-programs/tryout-archive-billing-programs.component.ts